export default {
  style: 10,
  entry_values: [{
    placeholder: "Type your choice here and press Enter",
    position: 0,
    text: "Pass"
  }, {
    placeholder: "Type your choice here and press Enter",
    position: 1,
    text: "Fail"
  }, {
    placeholder: "Type your choice here and press Enter",
    position: 2,
    text: "N/A"
  }]
};